import { TournamentLobbyScreen } from '@/screens/tournament/TournamentLobbyScreen'

export default function TournamentLobbyRoute() {
  return <TournamentLobbyScreen />
}
